/**
 * Extract the org slug from a wildcard subdomain.
 *
 * Production: acme.certify.skillform.ai  → "acme"
 *             certify.skillform.ai       → null
 * Dev:        localhost:3001?org=acme     → "acme"
 */
export function getOrgSlug() {
  const hostname = window.location.hostname;

  // Dev: use ?org= query param on localhost
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return new URLSearchParams(window.location.search).get('org');
  }

  // Production: {slug}.certify.skillform.ai
  const match = hostname.match(/^([\w-]+)\.certify\.skillform\.ai$/);
  if (match) return match[1];

  return null;
}
